import gql from 'graphql-tag'

const CompanyPartsFragment = gql`
  fragment CompanyParts on Company {
    id
    name
    city
    post_code
    street
    street_no
    street_no_flat
    nip
    krs
    regon
    email
    phone
    fax
    www
    roles
    logo {
      id
      url
      thumb_url
    }
  }
`

export const GET_COMPANIES = gql`
  query GetCompanies($page: Int, $size: Int) {
    companies(page: $page, size: $size) {
      list {
        ...CompanyParts
      }
      metadata {
        current_page
        total_pages
      }
    }
  }
${CompanyPartsFragment}
`

export const GET_COMPANY = gql`
  query GetCompany($id: ID, $main: Boolean) {
    company(id: $id, main: $main) {
      ...CompanyParts
    }
  }
${CompanyPartsFragment}
`
export const SAVE_COMPANY = gql`
  mutation createOrUpdateCompany($attributes: CompanyInput!) {
    createOrUpdateCompany(attributes: $attributes) {
      company {
        ...CompanyParts
      }
      errors
    }
  }
${CompanyPartsFragment}
`



// WEBPACK FOOTER //
// ./src/components/Companies/graphql.js